<template>
   <b-container>
      <h1 class="mb-4">Qualified Activities</h1>

      <b-card>
         <b-table
            :fields="[
               {key: 'name', sortable: true},
               {key: 'actions', label: ''},
            ]"
            sort-by="name"
            :items="activities"
            class="mb-0"
         >
            <template #cell(actions)="data">
               <div class="d-flex align-items-center justify-content-end cell-w-buttons">
                  <b-button
                     :id="`btn-delete-${data.item.id}`"
                     size="sm"
                     variant="danger"
                     @click="onDelete(data.item)"
                  >
                     Delete
                  </b-button>
               </div>
            </template>
         </b-table>
      </b-card>

      <b-modal
         id="modal-confirm-delete"
         title="Delete Qualified Activity"
         ok-title="Delete"
         ok-variant="danger"
         @ok="confirmDelete"
      >
         <p>
            Are you sure you want to delete qualified activity <b>{{ relatedStrings[0] }}</b
            >? Deletion is <b>permanent</b>. Restoring data, even from a recent backup, will be
            costly, time-intensive, and may be impossible. Deleting this item will permanently
            delete this item and the following related data:
         </p>

         <ul>
            <li v-for="item in relatedStrings.slice(1)" :key="item">{{ item }}</li>
         </ul>
      </b-modal>
   </b-container>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   data() {
      return {
         relatedData: {},
      };
   },

   computed: {
      ...mapGetters({
         activities: 'activities/activities',
      }),

      companyId() {
         return this.$route.params.id;
      },

      relatedStrings() {
         if (!this.relatedData._root) {
            return [];
         }
         const rootObj = this.relatedData[this.relatedData._root];
         const rootName = rootObj.name;

         const relatedStrings = [rootName];

         let timeSurveyDataCount = 0;
         rootObj.related.forEach((key) => {
            const obj = this.relatedData[key];
            if (obj.type === 'TimeSurveyBase_Activity') {
               timeSurveyDataCount += obj.count;
            }
         });

         if (timeSurveyDataCount > 0) {
            relatedStrings.push(
               `${timeSurveyDataCount} employee time records. This includes R&D activity contributions.`
            );
         }
         if (relatedStrings.length < 2) {
            relatedStrings.push('No related data');
         }

         return relatedStrings;
      },
   },

   methods: {
      async onDelete(activity) {
         const relatedData = await this.$store.dispatch('activities/deleteActivity', {
            activityId: activity.id,
         });
         this.relatedData = relatedData;
         this.$bvModal.show('modal-confirm-delete');
      },

      async confirmDelete() {
         const activityId = this.relatedData[this.relatedData._root].id;
         await this.blockingRequest('activities/deleteActivity', {
            activityId,
            force: true,
         });
      },
   },

   async created() {
      await this.blockingRequest('activities/loadActivities', {
         companyId: this.companyId,
      });
   },
};
</script>
